export const servicesText = {
  en: {
    heading: "Our Services",
    services: [
      {
        title: "Business Consulting ",
        desc: [
          "Streamline operations and improve efficiency",
          "Identify gaps in systems, processes, and execution",
          "Increase profitability through structured strategy",
          "Build a scalable and sustainable business foundation",
        ],
      },
      {
        title: "Business Investment Advisory",
        desc: [
          "Make informed decisions to grow your business capital",
          "Understand risks, returns, and strategic alignment",
          "Evaluate opportunities with clarity and confidence",
          "Develop long-term investment thinking",
        ],
      },
      {
        title: "Property Investment Advisory",
        desc: [
          "Maximise returns through structured property strategies",
          "Understand market dynamics and long-term value",
          "Reduce risk with informed decision-making",
          "Build a sustainable property portfolio",
        ],
      },
      {
        title: "Business Coaching",
        desc: [
          "Develop high-performing teams and leadership capability",
          "Strengthen decision-making and strategic thinking",
          "Align team performance with business goals",
          "Achieve measurable and consistent outcomes",
        ],
      },
      {
        title: "Leadership Development",
        desc: [
          "Enhance confidence, clarity, and leadership skills",
          "Improve communication and decision-making ability",
          "Align personal growth with professional direction",
          "Build resilience and long-term mindset",
        ],
      },
      {
        title: "Coach Training Program",
        desc: [
          "Become a certified and confident coach",
          "Build a structured and scalable coaching business",
          "Develop your personal brand and positioning",
          "Turn expertise into a sustainable income stream",
        ],
      },
    ],
  },

  vi: {
    heading: "Dịch Vụ",
    services: [
      {
        title: "Tư vấn Doanh nghiệp",
        desc: [
          "Tối ưu vận hành và nâng cao hiệu quả hoạt động",
          "Xác định điểm yếu trong hệ thống và quy trình",
          "Tăng lợi nhuận thông qua chiến lược bài bản",
          "Xây dựng nền tảng kinh doanh bền vững và có thể mở rộng",
        ],
      },
      {
        title: "Tư Vấn Đầu Tư Doanh Nghiệp",
        desc: [
          "Ra quyết định đầu tư thông minh để phát triển vốn",
          "Hiểu rõ rủi ro, lợi nhuận và định hướng chiến lược",
          "Đánh giá cơ hội với sự rõ ràng và tự tin",
          "Xây dựng tư duy đầu tư dài hạn",
        ],
      },
      {
        title: "Tư Vấn Đầu Tư Bất Động Sản",
        desc: [
          "Tối đa hóa lợi nhuận với chiến lược đầu tư bài bản",
          "Hiểu rõ thị trường và giá trị dài hạn",
          "Giảm thiểu rủi ro khi ra quyết định",
          "Xây dựng danh mục bất động sản bền vững",
        ],
      },
      {
        title: "Coaching Doanh Nghiệp",
        desc: [
          "Phát triển đội ngũ và năng lực lãnh đạo",
          "Nâng cao tư duy chiến lược và ra quyết định",
          "Đồng bộ hiệu suất đội ngũ với mục tiêu kinh doanh",
          "Đạt kết quả rõ ràng và ổn định",
        ],
      },
      {
        title: "Phát triển Năng lực Lãnh đạo",
        desc: [
          "Nâng cao sự tự tin và kỹ năng lãnh đạo",
          "Cải thiện giao tiếp và khả năng ra quyết định",
          "Định hướng phát triển cá nhân gắn với sự nghiệp",
          "Xây dựng tư duy bền vững và khả năng thích ứng",
        ],
      },
      {
        title: "Chương trình Đào tạo Coach",
        desc: [
          "Trở thành coach chuyên nghiệp và tự tin",
          "Xây dựng mô hình kinh doanh coaching bài bản",
          "Phát triển thương hiệu cá nhân rõ ràng",
          "Biến chuyên môn thành nguồn thu nhập bền vững",
        ],
      },
    ],
  },
};

export const ServiceText = {
  en: {
    sectionTitle: "Services",
    cards: [
      {
        quote: "Service 01",
        title: "Business ",
        subtitle: "Consulting Service",
        quote: "Operations · Revenue gap · 90-day plan",
        items: [],

        photo: "/maria/services/Business Consulting.png",
        path: "/services/business-consulting#businessconsulting",
        position: "leftTop",

        description:
          "Practical consulting solutions designed to help SMEs improve operations, profitability, and long-term business growth.",
      },

      {
        quote: "Service 02",
        title: "Business ",
        subtitle: "Investment Advisory",
        quote: "Business & property · ROI modelling",

        items: [],

        photo: "/maria/services/Business Investement.png",
        path: "/services/business-investment#businessinvestmentadvisory",
        position: "center",

        description:
          "Strategic investment guidance to help businesses grow smarter, minimise risk, and maximise long-term returns.",
      },

      {
        quote: "Service 03",
        title: "Property",
        subtitle: "Investment Advisory",
        quote: "High-value properties · Risk management",

        items: [],

        photo: "/maria/services/Property Investment.png",
        path: "/services/property-investment#propertyadvisory",
        position: "rightBottom",

        description:
          "Professional property investment guidance focused on sustainable growth, stronger returns, and smarter decisions.",
      },

      {
        quote: "Service 04",
        title: "Business ",
        subtitle: "Coaching & Training",
        quote: "8 sessions · 16 weeks · KPI system",
        favourite: "Most popular",
        items: [],

        photo: "/maria/services/Training & Coaching.png",
        path: "/services/training-coaching#trainingcoaching",
        position: "leftBottom",

        description:
          "Practical business training and coaching programs designed to improve leadership, performance, and business growth.",
      },

      {
        quote: "Service 05",
        title: "Leadership & Personal",
        subtitle: "Development",
        quote: "Mindset · Communication · Team culture",

        items: [
          "Build confidence and self-awareness",
          "Strengthen leadership mindset",
          "Improve communication skills",
          "Develop emotional resilience",
          "Create clearer personal direction",
        ],

        photo: "/maria/services/Leadership & Personal.png",
        path: "/services/leadership-development#consulting",
        position: "center",

        description:
          "Personal and professional development programs that help individuals lead with clarity, confidence, and purpose.",
      },

      {
        quote: "Service 06",
        title: "Become a Coach",
        subtitle: "& Coaching Business",
        quote: "Certified program · Build your practice",
        items: [],

        photo: "/maria/services/Become a Coach.png",
        path: "/services/coach-training#trainning",
        position: "rightTop",

        description:
          "Support and mentorship for aspiring coaches looking to build a successful and sustainable coaching business.",
      },
    ],
  },

  vi: {
    sectionTitle: "Dịch Vụ",
    cards: [
      {
        quote: "Dịch vụ 01",
        title: "Tư vấn",
        subtitle: "Doanh nghiệp",
        quote: "Vận hành · Doanh thu · Kế hoạch 90 ngày",

        items: [],

        photo: "/maria/services/Business Consulting.png",
        path: "/services/business-consulting#businessconsulting",
        position: "leftTop",

        description:
          "Giải pháp tư vấn thực tiễn giúp doanh nghiệp vừa và nhỏ tối ưu vận hành, nâng cao lợi nhuận và phát triển bền vững.",
      },

      {
        quote: "Dịch vụ 02",
        title: "Tư vấn",
        subtitle: "Đầu tư Doanh Nghiệp",
        quote: "Doanh nghiệp & bất động sản · Mô hình ROI",

        items: [],

        photo: "/maria/services/Business Investement.png",
        path: "/services/business-investment#businessinvestmentadvisory",
        position: "center",

        description:
          "Tư vấn đầu tư chiến lược giúp doanh nghiệp tăng trưởng thông minh, giảm thiểu rủi ro và tối đa hóa lợi nhuận dài hạn.",
      },

      {
        quote: "Dịch vụ 03",
        title: "Tư vấn",
        subtitle: "Đầu tư Bất động sản",
        quote: "Bất động sản giá trị · Quản trị rủi ro",

        items: [],

        photo: "/maria/services/Property Investment.png",
        path: "/services/property-investment#propertyadvisory",
        position: "rightBottom",

        description:
          "Dịch vụ tư vấn đầu tư bất động sản chuyên nghiệp, tập trung vào tăng trưởng bền vững và hiệu quả đầu tư lâu dài.",
      },

      {
        quote: "Dịch vụ 04",
        title: "Huấn Luyện",
        subtitle: "& Đào Tạo Doanh Nghiệp",
        quote: "8 buổi · 16 tuần · Hệ thống KPI",
        favourite: "Phổ biến nhất",

        items: [],

        photo: "/maria/services/Training & Coaching.png",
        path: "/services/training-coaching#trainingcoaching",
        position: "leftBottom",

        description:
          "Chương trình coaching và đào tạo thực tiễn giúp nâng cao năng lực lãnh đạo, hiệu suất làm việc và tăng trưởng doanh nghiệp.",
      },

      {
        quote: "Dịch vụ 05",
        title: "Phát triển",
        subtitle: "Lãnh đạo  & Bản Thân",
        quote: "Tư duy · Giao tiếp · Văn hóa đội ngũ",

        items: [
          "Xây dựng sự tự tin và nhận thức bản thân",
          "Phát triển tư duy lãnh đạo",
          "Nâng cao kỹ năng giao tiếp",
          "Tăng cường khả năng thích ứng và kiên cường",
          "Định hướng mục tiêu cá nhân rõ ràng hơn",
        ],

        photo: "/maria/services/Leadership & Personal.png",
        path: "/services/leadership-development#consulting",
        position: "center",

        description:
          "Chương trình phát triển cá nhân và nghề nghiệp giúp lãnh đạo với sự tự tin, rõ ràng và mục tiêu rõ rệt.",
      },

      {
        quote: "Dịch vụ 06",
        title: "Trở Thành Coach",
        subtitle: "& Phát Triển Coaching",
        quote: "Chứng nhận · Xây dựng nghề nghiệp",

        items: [],

        photo: "/maria/services/Become a Coach.png",
        path: "/services/coach-training#trainning",
        position: "rightTop",

        description:
          "Chương trình đào tạo và cố vấn dành cho những người muốn xây dựng sự nghiệp coaching chuyên nghiệp và bền vững.",
      },
    ],
  },
};
